import { Controller } from '@hotwired/stimulus'
import { TomSelectElement } from '../../types/common'

export default class FloatingLabelSelectController extends Controller<TomSelectElement> {
  connect() {
    setTimeout(this.#applyStylingToTomSelect.bind(this))
  }

  #applyStylingToTomSelect() {
    if (this.element.disabled) {
      this.element.parentElement.querySelector('.ts-wrapper').classList.add('bg-gray-50', 'hover:!border-gray-200')
    }
    this.element.tomselect.on('dropdown_open', () => {
      const tomSelectEmpty = this.element.parentElement.querySelector('[role=listbox] [role=option][data-value=""]')
      if (this.element.dataset.placeholder && tomSelectEmpty) {
        tomSelectEmpty.textContent = this.element.dataset.placeholder
      }
    })
  }
}
